import NextLink from 'next/link';

import { Container, Link, SectionText } from '@/atoms';
import { Card, SwiperCustom } from '@/molecules';

import type { TypeTextColorVariant } from '@/components/types';
import type { FunctionComponent } from 'react';
import type { TypeRecomendedProps } from './types';

const VARIANT_MAPS: Record<TypeTextColorVariant, string> = {
  primary: 'text-primary-400 ',
  secondary: 'text-secondary-400 ',
  alternative: 'text-white',
};
/** * Recomended */ export const Recomended: FunctionComponent<
  TypeRecomendedProps
> = ({
  className = '',
  backgroundColorBottom,
  backgroundColorBottomMobile,
  backgroundColorTop,
  backgroundColorTopMobile,
  caption,
  cards,
  cutLevel = 50,
  cutLevelMobile = 50,
  desc,
  textColor,
  title,
  index,
  id,
}: TypeRecomendedProps) => (
  <Container
    index={index}
    backgroundColorBottom={backgroundColorBottom}
    backgroundColorTopMobile={backgroundColorTopMobile}
    backgroundColorTop={backgroundColorTop}
    backgroundColorBottomMobile={backgroundColorBottomMobile}
    cutLevel={cutLevel === null ? 50 : cutLevel}
    cutLevelMobile={cutLevelMobile === null ? 50 : cutLevel}
    overflows
    className={`mx-5 flex flex-col gap-10  ${className}`}
    id={id}
  >
    <div className="flex w-full flex-col gap-10 lg:flex-row lg:gap-0">
      <div className="flex w-full flex-col gap-14 lg:max-w-[33%] lg:items-start">
        <SectionText
          className="w-3/4"
          direction="column"
          textAlign="start"
          title={title}
          desc={desc}
          caption={caption}
          variant={textColor}
        />
      </div>
      <div className="-mx-5 md:ml-0 lg:max-w-[55%]">
        <SwiperCustom
          scrollbar
          navigation
          gap={16}
          slidesPerView={3}
          slidesPerViewMobile={1.3}
          variants={textColor}
          slideGrow={true}
        >
          {cards.map((card, index: number) => (
            <Card
              multimediaProps={{ image: card.image }}
              key={index}
              backgroundColor={card.backgroundColor}
              className={`h-full md:ml-0 ${index === 0 ? 'ml-5' : ''} ${
                index === cards.length - 1 ? 'mr-5' : ''
              }`}
            >
              <div
                className={`flex h-full flex-col gap-3 ${VARIANT_MAPS[textColor]}`}
              >
                <span className="text-subtitle text-subtitle--small">
                  {card.title}
                </span>
                <span className="text-body text-body--secondary  mb-2">
                  {card.desc}
                </span>
                {card?.link?.src && (
                  <NextLink href={card.link.src} passHref prefetch={false}>
                    <Link variant={card.link?.variant} className="mt-auto">
                      {card.link.label}
                    </Link>
                  </NextLink>
                )}
              </div>
            </Card>
          ))}
        </SwiperCustom>
      </div>
    </div>
  </Container>
);
Recomended.displayName = 'Recomended';
